import { useRef } from 'react';

import { Icon } from '../../../../common/Icon';
import TiptapEditor, { TiptapEditorRef } from '../../../../common/TipTapEditor';
import { Spinner } from '../../../../components/Spinner';

import { getMarkdown } from './utils/utilityFunctions';

export interface GeneratedSummaryProps {
  todaysSummary: Record<string, string[]>;
  blockersSummary: string[];
  error?: string;
}

export function SummaryTextArea({
  generatedSummary,
  isLoading,
}: {
  generatedSummary: GeneratedSummaryProps;
  isLoading?: boolean;
}): JSX.Element {
  const editorRefs = useRef<Record<string, TiptapEditorRef | null>>({});

  const handleCopy = (type: string): void => {
    editorRefs.current[type]?.copyContent().catch((err) => {
      console.error('Failed to copy content:', err);
    });
  };

  const textAreas = [
    {
      type: 'todaysSummary',
      label: 'What did you do today?',
      inputData: generatedSummary.todaysSummary,
    },
    // {
    //   type: 'tomorrowsTodo',
    //   label: 'What do you plan on doing tomorrow?',
    //   inputData: '',
    //   setSummary: (input: string) =>
    //     setFinalSummary((prev: any) => ({
    //       ...prev,
    //       tomorrowsTodo: input,
    //     })),
    // },
    {
      type: 'blockersSummary',
      label: 'Any blockers?',
      inputData: generatedSummary.blockersSummary,
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-base font-nunito font-light text-[#434343]">
        Your Daily Stand Up Update Summary generated using AI.{' '}
      </h2>
      <div className="flex flex-col gap-2 relative border border-gray-300 rounded-md p-2 min-h-32">
        {isLoading || generatedSummary.error ? (
          <div className="flex absolute top-0 left-0 justify-center items-center w-full h-full bg-white/50">
            {generatedSummary.error ? (
              <p className="text-red-500">
                No checkins found. Please provide consistent checkins to get
                standup summary
              </p>
            ) : (
              <Spinner />
            )}
          </div>
        ) : (
          textAreas.map((textArea) => (
            <>
              <div className="flex justify-between items-center gap-2 text-base font-nunito font-bold p-2 text-[#434343]">
                <div>{textArea.label}</div>
                <Icon
                  name="clipboardcopy"
                  onClick={() => handleCopy(textArea.type)}
                  className="cursor-pointer hover:scale-110 transition-transform duration-150 w-4 h-4 text-[#434343] hover:text-[#141414]"
                />
              </div>
              <TiptapEditor
                key={textArea.type}
                ref={(el) => {
                  editorRefs.current[textArea.type] = el;
                }}
                showBulletPoints
                initialContent={getMarkdown(textArea.inputData)}
                placeholder="Please add your summary here"
                className="border rounded-lg p-4"
              />
            </>
          ))
        )}
      </div>
    </div>
  );
}
